import config, { API_BASE_URL_KEY } from "config";

export default {
  APP_VERSION: process.env.REACT_APP_APP_VESION,
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || config.get(API_BASE_URL_KEY),
  FAKE_SERVER_URL: process.env.REACT_APP_FAKE_SERVER_URL,
  JSON_SERVER_URL: process.env.REACT_APP_JSON_SERVER_URL,
  POSTHOG_KEY: process.env.REACT_APP_POSTHOG_KEY,
  POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST,
  WS_BASE_URL: process.env.REACT_APP_WS_BASE_URL,
  WORKFLOW_ONBOARDING: process.env.REACT_APP_WORKFLOW_ONBOARDING,
  ONBOARDING_API_KEY: process.env.REACT_APP_ONBOARDING_API_KEY,
  LEADSTATS_LOGIN_URL: process.env.REACT_APP_LEADSTATS_LOGIN_URL,
  storageKeys: {
    USER_DATA: "userData",
  },
};
